import React, { useEffect, useMemo, useState } from "react";
import { Card, CardContent, Typography, Chip, LinearProgress, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { linearProgressClasses } from "@mui/material/LinearProgress";

const money = (n) =>
    (n ?? 0).toLocaleString(undefined, { style: "currency", currency: "LKR", maximumFractionDigits: 0 });

const percent = (a, b) => (b > 0 ? Math.round((a / b) * 100) : 0);


export default function ProgressCard({ title, numerator, denominator, moneyMode = false }) {
    const pct = percent(numerator, denominator);

    const CustomLinearProgress = styled(LinearProgress, {
        shouldForwardProp: (prop) => prop !== "value", // don't forward 'value' to DOM
    })(({ theme, value }) => ({
        //   height: 12,
        borderRadius: 6,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[300],
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 6,
            width: value + '%',
            backgroundColor:
                value < 30
                    ? theme.palette.error.main   // red if < 30%
                    : value < 70
                        ? theme.palette.warning.main // orange if 30–70%
                        : theme.palette.success.main // green if > 70%
        },
    }));
    return (
        <Card className="rounded-2xl shadow-sm">
            <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center" className="mb-2">
                    <Typography variant="subtitle2" color="text.secondary">
                        {title}
                    </Typography>
                    <Chip size="small" label={`${pct}%`} />
                </Stack>
                <CustomLinearProgress variant="determinate" value={pct} />
                <Typography variant="caption" color="text.secondary" className="mt-2 block">
                    {moneyMode
                        ? `${money(numerator)} / ${money(denominator)}`
                        : `${numerator} / ${denominator}`}
                </Typography>
            </CardContent>
        </Card>
    );
}